import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MetaService } from '@core/services/seo/meta-tag-service';
import { select, Store } from '@ngrx/store';
import { catchError, delay, of, Subject, Subscription, switchMap, tap } from 'rxjs';
import { ApiService } from '@core/services/api/api.service';
import { HelperService } from '@core/services/api/helper.service';
import { ContentfulService } from '@core/services/cms/contentful.service';
import * as CatalogActions from '@core/state/catalog/catalog.actions';
import * as fromCatalog from '@core/state/catalog/catalog.selectors';


@Component({
  selector: 'app-product-all',
  templateUrl: './product-all.component.html',
  styleUrls: ['./product-all.component.scss'],

})
export class ProductAllComponent implements OnInit {

  allHeroEntries= {};
  allSubcategories= {};
  hero: any;
  subcategory: any;
  currentPage: number = 1;
  itemsPerPage: number; // Adjust the number of items per page as needed
  totalPages: number;
  filters: any;
  countProductsResult: number;
  isFilterListVisible: boolean = true;
  loading: boolean = false;
  
  mongoParam: any;
  selectedFilters: string[] = [];
  selectedOptions: { [key: string]: string[] } = {};
  selectedSortOption: string = ''; // Initialize the selected sort option as an empty string
  filterParams: { [key: string]: any }[] = [];
  queryHeader: string[];

  public mongo: any;
  query: any;
  screenWidth: any;

  public brands: any
  public brand: any;
  
  public categoriesFilter: any
  public category: string = '';

  public decorations: any
  public decorationType: string = '';

  public custom: string = '';


  public search;
  public searchInputParam: string = ''
  
  public destroyed = new Subject<void>()
  public viewport

  public products: any;
  public subscription: Subscription[] = [];

  colors: any[] = ['Blacks', 'Blues', 'Browns', 'Greens', 'Oranges', 'Pinks', 'Purples', 'Reds', 'Whites', 'Yellows']

  sizes: any[] = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', 'Other'] 

  thickness: any[] = [
    {label:'Lightweight (5oz. or below)', value: '0-0.20'},
    {label:'Standard (5-6 oz.)', value: '0.21-0.35'},
    {label:'Heavyweight (6oz. or more)', value: '0.36-50'},
  ] 

  price: any[] = ['0.00-5.00','5.00-10.00', '10.00-25.00', '25.00-50.00', '50.00-100.00'] 

  productDecorationSubscription: any;
  productBrandsSubscription: any;
  productCategoriesSubscription: Subscription;

  queryHeaderSubscription: Subscription;
  countProductSubscription: Subscription;
  catalogTotalPagesSubscription: Subscription;
  catalogQuerySubscription: Subscription;
  catalogFiltersSubscription: Subscription;
  catalogProductSubscription: Subscription;
  catalogCategoriesFilterSubscription: Subscription;
  catalogBrandsFilterSubscription: Subscription;
  brandsFilter: any[];

  constructor(
    protected api: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private helper: HelperService, 
    private contentfulService: ContentfulService,
    private store: Store,
    private metaService: MetaService
    
  ) { 
    this.countProductSubscription = this.store.pipe(select(fromCatalog.selectCatalogTotalProductsCount)).subscribe((totalCount => { this.countProductsResult = totalCount }));
    this.subscription.push(this.countProductSubscription)

    this.catalogTotalPagesSubscription =this.store.pipe(select(fromCatalog.selectCatalogTotalPages)).subscribe((totalPages => { this.totalPages = totalPages }));
    this.subscription.push(this.catalogTotalPagesSubscription)

    this.catalogQuerySubscription = this.store.pipe(select(fromCatalog.selectCatalogQuery)).subscribe((searchQuery => { this.mongoParam = searchQuery }));
    this.subscription.push(this.catalogQuerySubscription)

    this.catalogFiltersSubscription = this.store.pipe(select(fromCatalog.selectCatalogFilters)).subscribe((filters => {
      this.filters = filters 

    }));
    this.subscription.push(this.catalogFiltersSubscription)

    this.catalogBrandsFilterSubscription = this.store.pipe(select(fromCatalog.selectBrandsNav)).subscribe((brands) => {
      this.brandsFilter = brands
    });
    this.subscription.push(this.catalogBrandsFilterSubscription)

    this.catalogCategoriesFilterSubscription = this.store.pipe(select(fromCatalog.selectCategoriesNav)).subscribe((categories) => {
      this.categoriesFilter = categories
    });
    this.subscription.push(this.catalogCategoriesFilterSubscription)

    this.catalogProductSubscription = this.store.pipe(select(fromCatalog.selectProducts)).subscribe((products => { 
      this.products = products
      this.itemsPerPage = this.products.length;
    }));
    this.subscription.push(this.catalogProductSubscription)

  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      this.search =  this.helper.lowerCase(Object.keys(params).toString() == 'search' ? Object.values(params).toString() : '')
      this.category =  this.helper.lowerCase(Object.keys(params).toString() == 'categories' ? Object.values(params).toString() : this.category)
      this.brand = this.helper.lowerCase(Object.keys(params).toString() == 'brand' ? Object.values(params).toString() : '')
      this.decorationType = this.helper.lowerCase(Object.keys(params).toString() == 'decoration' ? Object.values(params).toString() : '')

      this.query = this.decorationType ? this.decorationType : this.category ? this.category : this.brand ? this.brand : null;  
      
      const queryMetadata = this.metaService.extractSearchParamsAsString(params)
      this.metaService.updateMetaTags(
        `${queryMetadata ? queryMetadata : 'No Results'}`,
        `Browse ${queryMetadata ? queryMetadata: 'products'} in the Catalog on the Culture Studio Platform`,
        `Browse for ${queryMetadata ?  queryMetadata : 'products'} in the Catalog on the Culture Studio Platform`,
        `https://img.stokkup.com/app/cs-circle-logo.png`,
      )

      this.contentfulService.getHeroEntries()
      .then((response) => {
          response.forEach((category) => {
            this.allHeroEntries[category.fields.heroCategoryName] = category.sys.id;
          });
  
          if(Boolean(this.search)) {
            for (const [key, value] of Object.entries(this.allHeroEntries)) {
              if(key.toLowerCase() == this.search.toLowerCase()) {
                this.store.pipe(select(fromCatalog.selectHero(key))).subscribe((hero => { this.hero = hero }));
              }
            }
          } else if(Boolean(this.query)) {
            for (const [key, value] of Object.entries(this.allHeroEntries)) {
              if(key.toLowerCase() == this.query.toLowerCase()) {
                this.store.pipe(select(fromCatalog.selectHero(key))).subscribe((hero => { this.hero = hero }));
              }
            }     
          } else {
            this.store.pipe(select(fromCatalog.selectHero('home'))).subscribe((hero => { this.hero = hero }));
  
          }
      });

      this.contentfulService.getSubcategories()
      .then((response) => {
        response.forEach((subcategory) => {
          this.allSubcategories[subcategory.fields.mainCategory] = subcategory.sys.id;
        });
        if(Boolean(this.search)) {
          for (const [key, value] of Object.entries(this.allSubcategories)) {
            if(key.toLowerCase() == this.search.toLowerCase()) {
              this.store.pipe(select(fromCatalog.selectSubcategory(key))).subscribe((subcategory => { this.subcategory = subcategory }));
            }
          }
        } else if(Boolean(this.query)) {
          for (const [key, value] of Object.entries(this.allSubcategories)) {
            if(key.toLowerCase() == this.query.toLowerCase()) {
              this.store.pipe(select(fromCatalog.selectSubcategory(key))).subscribe((subcategory => { this.subcategory = subcategory }));
            }
          }     
        }
      });

      this.screenWidth = window.innerWidth;

      this.setupStickyList();
    })

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = window.innerWidth;
  }

  hideFilterList() {
    const filterListElement = document.getElementById('sticky-filter');
    if (this.isFilterListVisible) {
      filterListElement.style.opacity = '0';
      setTimeout(() => {
        filterListElement.style.display = 'none';
        filterListElement.classList.remove('fade-out');
      }, 1); // Delay should match the transition duration in CSS
    } else {
      filterListElement.style.display = 'block';
      setTimeout(() => {
        filterListElement.style.opacity = '1';
      }, 10); // Small delay to ensure display property is set before the fade-in animation starts
    }
    this.isFilterListVisible = !this.isFilterListVisible;
  }

  applyFilter(name, filter) {

    if (!this.selectedOptions[name]) {
      this.selectedOptions[name] = [];
    }
  
    if (this.isSelected(name, filter)) {
      // Option is already selected, remove it
      this.selectedOptions[name] = this.selectedOptions[name].filter(o => o !== filter);
    } else {
      // Option is not selected, add it
      this.selectedOptions[name].push(filter);
    }
  
    // 1. Set parameters
    this.currentPage = 1;

    // 2. Push selected filters to chips
    const filterValue = typeof filter === "object" && filter !== null ? filter.value : filter;
    const index = this.selectedFilters.indexOf(filterValue);

    if (index > -1) {
      // Option already exists, so remove it
      this.selectedFilters.splice(index, 1);
    } else {
      // Option doesn't exist, so add it
      this.selectedFilters.push(filterValue);
    }
  
    // 3. Update query params in URL
    this.filterParams = []; // Clear the existing filterParams array
  
    Object.entries(this.selectedOptions).forEach(([key, values]) => {
      if (Array.isArray(values)) {
        values.forEach(value => {
          const existingFilter = this.filterParams.some(obj => obj[key] === value);
          if (!existingFilter) {
            const newFilter = { [key]: value };
            this.filterParams.push(newFilter);
          }
        });
      }
    });
  }

  submitFilters() {
    let originalParam = this.mongoParam?.[0] //get original 
    //1. update catalog query in store
    this.store.dispatch(CatalogActions.updateCatalogQuery(
      {
        queryUpdate: originalParam ? [originalParam, ...this.filterParams] : this.filterParams,
        currentPage: this.currentPage ?  this.currentPage : 1,
        sort:  this.selectedSortOption ? this.selectedSortOption : 'A-Z'
      }
    ));
    const queryFilters = this.metaService.extractValuesAsString(this.mongoParam)

    if(queryFilters) {
      this.metaService.updateMetaTags(
        `${queryFilters ? queryFilters: 'No Results'}`,
        `Browse ${queryFilters ? queryFilters : 'products'} in the Catalog on the Culture Studio Platform`,
        `Browse for ${queryFilters ? queryFilters : 'products'} in the Catalog on the Culture Studio Platform`,
        `https://img.stokkup.com/app/cs-circle-logo.png`,
      )
    }
    //2. get new products with new query
    this.store.dispatch(CatalogActions.getCatalogProducts({
      searchParam: this.mongoParam,
      currentPage: this.currentPage,
      sort: this.selectedSortOption ? this.selectedSortOption : 'A-Z'
    }));
  }

  clearFilters() {
    //1. clear all params & filters
    let originalParam = [this.mongoParam[0]] //get original 
    this.selectedOptions = {}; // Clear filter dropdown
    this.selectedSortOption = '';
    this.filterParams = []; // Clear the existing filterParams array
    this.selectedFilters = []; // Clear filter chips
    this.currentPage = 1;

    //2. update query in store
    this.store.dispatch(CatalogActions.updateCatalogQuery(
      {
        queryUpdate: originalParam,
        currentPage: this.currentPage,
        sort:  this.selectedSortOption ? this.selectedSortOption : 'A-Z'

      }
    ));
    
    //3. use new query from store to get new products
    this.store.dispatch(CatalogActions.getCatalogProducts({
      searchParam: this.mongoParam,
      currentPage: 1,
      sort: 'A-Z'
    }));
  }

  getMoreProducts(page: number, sortOption: string) {
    this.loading = true

    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;

      this.store.dispatch(CatalogActions.updateCatalogQuery(
        {
          queryUpdate: this.mongoParam,
          currentPage: this.currentPage ?  this.currentPage : 1,
          sort:  this.selectedSortOption ? this.selectedSortOption : 'A-Z'
        }
      ));


      this.store.dispatch(CatalogActions.getCatalogProducts(
        {
          searchParam: this.mongoParam,
          currentPage: page,
          sort: sortOption ? sortOption : 'A-Z'
        }
      ));

          // Use switchMap to handle product subscription and finalize to handle loading
    // this.store.pipe(
    //   select(fromCatalog.selectProducts),
    //   switchMap((products) => {
    //     this.products = products;
    //     return of(products); // Return the products for the switchMap
    //   }),
    //   catchError((error) => {
    //     // Handle error if needed
    //     return of([]); // Return an empty array to avoid breaking the pipeline
    //   }),
    //   delay(1000),
    //   tap(() => {
    //     this.loading = false; // Set loading to false after products are loaded
    //   })
    // ).subscribe();      
    }

    
  }

  get currentPageRange() {
    const end = this.products?.length ?? 0
    const gTotal = +end > +this.countProductsResult ? +end : +this.countProductsResult;
    if(Array.isArray(this.mongoParam)) {
      this.store.pipe(select(fromCatalog.selectPrimaryQueryHeader())).subscribe((queryHeader => { 
        this.queryHeader = queryHeader;
      }));
      // return `${end} of ${gTotal} results of ${this.mongoParam.map(obj => Object.values(obj)).join(', ')}`;
      return `${end} of ${gTotal} Products`;
    }
  }

  browseSubcategory(category) {
    //1. format category received from Contentful
    let subCategoryParam = [
      {categories: category}
    ]
    this.currentPage = 1;

    // 2. update query in store
    this.store.dispatch(CatalogActions.updateCatalogQuery(
      {
        queryUpdate: subCategoryParam,
        currentPage: this.currentPage,
        sort:  this.selectedSortOption ? this.selectedSortOption : 'A-Z'
      }
    ));

    //3. use new query from store to get new products
    this.store.dispatch(CatalogActions.getCatalogProducts({
      searchParam: this.mongoParam,
      currentPage: this.currentPage,
      sort: 'A-Z'
    }));
  }

  getValueFromObject(obj: any): string {
    if (typeof obj === 'object' && obj !== null) {
      const key = Object.keys(obj)[0];
      const result =
        obj[key] === '0-0.20'
          ? 'Lightweight (5oz. - below)'
          : obj[key] === '0.21-0.35'
          ? 'Standard (5-6oz.)'
          : obj[key] === '0.36-50'
          ? 'Heavyweight (6oz. - above)'
          : obj[key].toLowerCase() === 'private label'
          ? 'Custom'
          : obj[key];
      return result;
    }
    return obj;
  }

  removeTag(tag: string) {

    const filterArray = this.filterParams.map(obj => JSON.stringify(obj));
    const index = filterArray.findIndex(item => item === JSON.stringify(tag));
    
    if (index !== -1) {
      this.filterParams.splice(index, 1);
    }

    let originalParam = [this.mongoParam[0]]
      //1. update catalog query in store
      if( this.mongoParam.length === 1 ) {
        this.currentPage = null

        this.store.dispatch(CatalogActions.updateCatalogQuery(
          {
            queryUpdate: null,
            currentPage: null,
            sort:  this.selectedSortOption ? this.selectedSortOption : 'A-Z'
          }
        ));
        this.brand = ''
        this.category = ''
        this.router.navigate(['/catalog']) 

      } else {
        this.store.dispatch(CatalogActions.updateCatalogQuery(
          {
            queryUpdate: originalParam ? [...originalParam, ...this.filterParams] : this.filterParams,
            currentPage: this.currentPage,
            sort:  this.selectedSortOption ? this.selectedSortOption : 'A-Z'
          }
        ));
        
        const queryFilters = this.metaService.extractValuesAsString(this.mongoParam)

        if(queryFilters) {
          this.metaService.updateMetaTags(
            `${queryFilters ? queryFilters: 'No Results'}`,
            `Browse ${queryFilters ? queryFilters : 'products'} in the Catalog on the Culture Studio Platform`,
            `Browse for ${queryFilters ? queryFilters : 'products'} in the Catalog on the Culture Studio Platform`,
            `https://img.stokkup.com/app/cs-circle-logo.png`,
          )
        }

        //2. get new products with new query
        this.store.dispatch(CatalogActions.getCatalogProducts({
          searchParam: this.mongoParam,
          currentPage: this.currentPage,
          sort: this.selectedSortOption ? this.selectedSortOption : 'A-Z'
        }));
      }
    
  }
  
  
  
  isSelected(key: string, option: string): boolean {
    return this.selectedOptions[key]?.includes(option) ?? false;
  }


     /**
   * Mongo endpoint to get the products from the specific category
   */
    // protected mongoGetProducts(){
    //   this.products = this.mongo;
    // }

  setupStickyList() {
    window.addEventListener('scroll', () => {
      const listElement = document.getElementById('sticky-list');
      const listOffsetTop = listElement?.offsetTop;

      if (listElement && window.pageYOffset >= listOffsetTop) {
        listElement.classList.add('sticky');
      } else if (listElement) {
        listElement.classList.remove('sticky');
      }
    });
  }

  

  formatProductsMongo(search, brand, category, decorationType) {
    let mongoParam = [];
  
    if (search) {
      let searchQuery = {}
      mongoParam.push(searchQuery);
    }
  
    if (brand) {
      let brandQuery = {'brand' : brand}
      mongoParam.push(brandQuery);
    }
  
    if (category) {
      let categoryQuery = {'categories': category}
      mongoParam.push(categoryQuery);
    }
    
    if (decorationType) {
      let decorationQuery = {}
      mongoParam.push(decorationQuery);
    }

    return mongoParam;
  }

  sortProducts(type) {
    this.selectedSortOption = type;

    let originalParam = [this.mongoParam[0]] //get original 


      this.store.dispatch(CatalogActions.updateCatalogQuery(
        {
          queryUpdate: originalParam ? [...originalParam, ...this.filterParams] : this.filterParams,
          currentPage: this.currentPage ?  this.currentPage : 1,
          sort: this.selectedSortOption ? this.selectedSortOption : 'A-Z'
        }
      ));
  
      //2. get new products with new query
      this.store.dispatch(CatalogActions.getCatalogProducts({
        searchParam: this.mongoParam,
        currentPage: this.currentPage,
        sort: type // use selected sort type
      }));
  }


  ngOnDestroy() {
    // Unsubscribe to prevent memory leaks when the component is destroyed
    this.subscription.forEach((subscription) => subscription.unsubscribe());
  }
}
